// 考试模块路由 test

export default [
  // 考试首页
  {
    path: '/ExamIndex',
    name: 'ExamIndex',
    component: () =>
    import(/* webpackChunkName: "exam" */ '@/components/bloom-test/exam/index')
  },
  // 考试试卷
  {
    path: '/ExamPaper',
    name: 'ExamPaper',
    component: () =>
    import(/* webpackChunkName: "exam" */ '@/components/bloom-test/exam/paper')
  },
  // 考试结束
  {
    path: '/ExamEnd',
    name: 'ExamEnd',
    component: () =>
    import(/* webpackChunkName: "exam" */ '@/components/bloom-test/exam/end')
  },
  // 练习首页
  {
    path: '/ExerciseIndex',
    name: 'ExerciseIndex',
    component: () =>
    import(/* webpackChunkName: "exercise" */ '@/components/bloom-test/exercise/index')
  },
  // 练习试卷
  {
    path: '/ExercisePaper',
    name: 'ExercisePaper',
    component: () =>
    import(/* webpackChunkName: "exercise" */ '@/components/bloom-test/exercise/paper')
  },
  // 练习结束
  {
    path: '/ExerciseEnd',
    name: 'ExerciseEnd',
    component: () =>
    import(/* webpackChunkName: "exercise" */ '@/components/bloom-test/exercise/end')
  },
  // 考试错过
  {
    path: '/ExamSystemMiss',
    name: 'ExamIndex',
    component: () =>
    import(/* webpackChunkName: "exam-system" */ '@/components/bloom-test/exam-system/miss')
  },
  // 考试系统首页
  {
    path: '/ExamSystemIndex',
    name: 'ExamIndex',
    component: () =>
    import(/* webpackChunkName: "exam-system" */ '@/components/bloom-test/exam-system/index')
  },
  // 考试系统试卷
  {
    path: '/ExamSystemPaper',
    name: 'ExamPaper',
    component: () =>
    import(/* webpackChunkName: "exam-system" */ '@/components/bloom-test/exam-system/paper')
  },
  // 考试系统结束
  {
    path: '/ExamSystemEnd',
    name: 'ExamEnd',
    component: () =>
    import(/* webpackChunkName: "exam-system" */ '@/components/bloom-test/exam-system/end')
  },
  // 平板扫码跳转
  {
    path: '/proctor',
    name: 'proctorIpad',
    component: () =>
    import(/* webpackChunkName: "exam-system" */ '@/components/bloom-test/exam-system/proctor')
  },
  // 测试试卷
  {
    path: '/AssessmentPaper',
    name: 'AssessmentPaper',
    component: () =>
    import(/* webpackChunkName: "Assessment" */ '@/components/bloom-test/assessment/paper')
  },
  // 测试结果
  {
    path: '/AssessmentEnd',
    name: 'AssessmentEnd',
    component: () =>
    import(/* webpackChunkName: "Assessment" */ '@/components/bloom-test/assessment/end')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/bloom-test.js